import React from 'react';
import { History, ArrowUpRight } from 'lucide-react';
import { fmtEur } from './QuoteForm';

export const QuoteHistory = ({ opportunity, opportunities, onOpen }) => {
    if (!opportunity?.quote) return null;
    const byId = Object.fromEntries(opportunities.map(o => [o.id, o]));

    const ancestors = [];
    let cur = opportunity;
    const seen = new Set([opportunity.id]);
    while (cur?.quote?.parent_id && byId[cur.quote.parent_id] && !seen.has(cur.quote.parent_id)) {
        cur = byId[cur.quote.parent_id];
        seen.add(cur.id);
        ancestors.unshift(cur);
    }

    const collectDescendants = (id) =>
        opportunities
            .filter(o => o.quote?.parent_id === id)
            .flatMap(o => [o, ...collectDescendants(o.id)]);
    const descendants = collectDescendants(opportunity.id);

    if (ancestors.length === 0 && descendants.length === 0) return null;
    const chain = [...ancestors, opportunity, ...descendants];

    return (
        <div className="rounded-sm border p-4 space-y-2" data-testid="quote-history">
            <h4 className="font-heading uppercase text-sm tracking-wider flex items-center gap-2">
                <History size={14} /> Storico revisioni
            </h4>
            <ol className="relative border-l-2 border-muted ml-2 space-y-1">
                {chain.map((o) => {
                    const isCurrent = o.id === opportunity.id;
                    return (
                        <li key={o.id} className="ml-4 relative">
                            <span
                                className={`absolute -left-[23px] top-2 h-3 w-3 rounded-full border-2 border-background ${isCurrent ? 'bg-primary' : 'bg-muted-foreground/50'}`}
                            />
                            <button
                                type="button"
                                disabled={isCurrent}
                                onClick={() => onOpen(o)}
                                className={`w-full text-left flex items-center justify-between gap-3 rounded-sm px-2 py-1.5 text-sm transition-colors ${isCurrent ? 'bg-muted font-semibold' : 'hover:bg-muted/60'}`}
                                data-testid={`quote-history-item-${o.id}`}
                            >
                                <span className="font-mono">{o.quote.number}</span>
                                <span className="text-muted-foreground text-xs truncate flex-1">
                                    {o.quote.offer_date || ''}{o.quote.revision_note ? ` · ${o.quote.revision_note}` : ''}
                                </span>
                                <span className="font-mono">{fmtEur(o.value)}</span>
                                {isCurrent ? (
                                    <span className="text-[10px] uppercase tracking-wider text-primary">attuale</span>
                                ) : (
                                    <ArrowUpRight size={14} className="text-muted-foreground" />
                                )}
                            </button>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};
